import { GiphyFetch } from '@giphy/js-fetch-api';
import { ImageAllTypes } from '@giphy/js-types';
import { Grid } from '@giphy/react-components';
import { IStoryItem, StoryType } from 'interfaces/addStory.interface';
import React, { FC, useEffect, useRef, useState } from 'react';
import {
  Mention,
  MenuCont,
  MenuItem,
  MenuItemsCont,
  MenuSearchInput,
  Sticker,
} from './StoryMainCont.styles';

interface IStoryMainMenuCont {
  hideUI: () => void;
  showMentionMenu: () => void;
  showGifMenu: () => void;
  showLinkMenu: () => void;
  addToStoryBoard?: (data: IStoryItem) => void;
  apiKey?: string;
}

const StoryMainMenuCont: FC<IStoryMainMenuCont> = ({
  showMentionMenu,
  addToStoryBoard,
  hideUI,
  showGifMenu,
  showLinkMenu,
  apiKey,
}) => {
  const mentionImg = require('assets/icons/quote-left-solid.svg');
  const gifImg = require('assets/icons/images-solid.svg');
  const linkImg = require('assets/icons/link-solid.svg');
  const stickerImg = require('assets/skull-sticker.png');
  const stickerImg2 = require('assets/appicon.png');

  const localAddToStoryBoard = (imgUrl: string) => {
    if (addToStoryBoard) {
      const data: IStoryItem = {
        id: 0,
        position: {
          X: 50,
          Y: 50,
        },
        size: {
          X: 100,
          Y: 100,
        },
        type: StoryType.Sticker,
        url: imgUrl,
      };
      addToStoryBoard(data);
      hideUI();
    }
  };

  const localAddGifToStoryBoard = (gifImg: ImageAllTypes) => {
    if (addToStoryBoard) {
      const data: IStoryItem = {
        id: 0,
        position: {
          X: 50,
          Y: 50,
        },
        size: {
          X: gifImg.width / 2,
          Y: gifImg.height / 2,
        },
        type: StoryType.GIF,
        url: gifImg.url,
      };
      addToStoryBoard(data);
      hideUI();
    }
  };

  const gf = new GiphyFetch(apiKey || '');

  const fetchGifs = (offset: number) =>
    gf.search(searchTerm, { offset, limit: 10 });

  const [gridWidth, setGridWidth] = useState<number>(300);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const mainCont = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (mainCont.current) {
      setGridWidth(mainCont.current.clientWidth - 30);
    }
  }, [mainCont]);

  return (
    <MenuCont ref={mainCont} className="scrollbar-hidden">
      <MenuSearchInput
        type="text"
        placeholder="Search..."
        onChange={e => setSearchTerm(e.target.value)}
        value={searchTerm}
      />

      {searchTerm.length > 1 ? (
        <Grid
          width={gridWidth}
          columns={3}
          onGifClick={(gif, e) => {
            e.preventDefault();
            localAddGifToStoryBoard(gif.images.original);
          }}
          gutter={10}
          fetchGifs={fetchGifs}
          key={searchTerm}
        />
      ) : (
        <MenuItemsCont container className="scrollbar-hidden">
          <MenuItem item xs={4}>
            <Mention
              src={mentionImg.default}
              onClick={() => showMentionMenu()}
            />
          </MenuItem>
          <MenuItem item xs={4}>
            <Mention src={gifImg.default} onClick={() => showGifMenu()} />
          </MenuItem>
          <MenuItem item xs={4}>
            <Mention src={linkImg.default} onClick={() => showLinkMenu()} />
          </MenuItem>
          <MenuItem item xs={4}>
            <Sticker
              src={stickerImg2}
              onClick={() => localAddToStoryBoard(stickerImg2)}
            />
          </MenuItem>
          <MenuItem item xs={4}>
            <Sticker
              src={stickerImg}
              onClick={() => localAddToStoryBoard(stickerImg)}
            />
          </MenuItem>
          <MenuItem item xs={4}>
            <Sticker
              src={stickerImg2}
              onClick={() => localAddToStoryBoard(stickerImg2)}
            />
          </MenuItem>
          <MenuItem item xs={4}>
            <Sticker
              src={stickerImg}
              onClick={() => localAddToStoryBoard(stickerImg)}
            />
          </MenuItem>
          <MenuItem item xs={4}>
            <Sticker
              src={stickerImg2}
              onClick={() => localAddToStoryBoard(stickerImg2)}
            />
          </MenuItem>
        </MenuItemsCont>
      )}
    </MenuCont>
  );
};

export default StoryMainMenuCont;
